import React, { useState } from "react";
import "./Map.sass";
import Map from "../../Modules/Map";
import MapItems from "./Component/MapItems";
import LocationData from "../../Assets/Data/maps";

const MapPage = () => {
  const [markers, setMarkers] = useState(LocationData.Halls);

  return (
    <div className="mapApp">
      <Map markers={markers}>
        <MapItems setMarkers={setMarkers} />
      </Map>
    </div>
  );
};
export default MapPage;
